import { render, staticRenderFns } from "./YyxmAdd.vue?vue&type=template&id=17636252"
import script from "./YyxmAdd.vue?vue&type=script&lang=js"
export * from "./YyxmAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports